:host {
    display: flex inline;
    flex-direction: column;
}

ux-icon {
    font-size: 0.75rem;
}